import type { CaClaimantsData, PageProps } from '@/types/index';
import type { NextPage, GetStaticProps } from 'next';
import * as Sentry from '@sentry/nextjs';
import { restRequest } from '@/utils/restRequest';
import RichText from '@/components/RichText';
import PageHead from '@/components/Head';
import { domain, revalidate } from '@/constants/config';
import styles from '../styles/CaClaimants.module.css';
export const getStaticProps: GetStaticProps = async () => {
  let claimantsData: CaClaimantsData | null = null;
  const fallbackId = 'd3b6f600b58f48ac911ba1f2a9cd106c';
  try {
    const claimantsDataArr = await restRequest<CaClaimantsData[]>({
      modelName: 'ca-claimants',
      query: `data.domains.domain.id=${domain}`,
      fallback: fallbackId
    });
    const primaryItem = claimantsDataArr?.find(item => item.id !== fallbackId);
    const fallbackItem = claimantsDataArr?.find(item => item.id === fallbackId);
    claimantsData = primaryItem ?? fallbackItem ?? null;
  } catch {
    claimantsData = null;
  }
  return {
    props: {
      content: {
        claimantsData
      }
    },
    revalidate
  };
};
export const Page: NextPage<PageProps> = ({
  content
}) => {
  const {
    claimantsData
  } = content;
  const data = claimantsData?.data;
  const lawyers = data?.lawyers;
  const topText = data?.top?.value?.data?.text;
  const bottomText = data?.bottom?.value?.data?.text;
  if (!data) {
    Sentry.captureMessage('No ca-claimants data returned for domain', {
      level: 'warning',
      tags: {
        page: 'california-claimants'
      },
      contexts: {
        request_context: {
          domain
        }
      }
    });
  }
  return <>
			<PageHead path="/california-claimants" title="Total Injury Help | California Claimants" description="" shareImage="/TotalInjuryHelp_logo.webp" preventIndexing={true} data-sentry-element="PageHead" data-sentry-source-file="california-claimants.tsx" />

			<div className={styles.caClaimantsContainer}>
				<>
					{topText && <RichText text={topText} />}
					{lawyers && <p>{lawyers}</p>}
					{bottomText && <RichText text={bottomText} />}
				</>
			</div>
		</>;
};
export default Page;